// Link digitado sem esquema ("www.loja.com.br", "loja.com.br/x") ganha
// https:// — o mesmo que o servidor faz (LayoutCatalog.safe_url).
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const BARE_DOMAIN = /^[^\s/{#?]+\.[^\s]+$/;

export const withScheme = raw => {
  const value = String(raw ?? '').trim();
  if (!HAS_SCHEME.test(value) && BARE_DOMAIN.test(value)) {
    return `https://${value}`;
  }
  return value;
};

// Link do editor de texto: "https://" sozinho (campo vazio) tira o link.
export const normalizeHref = raw => {
  const value = withScheme(raw);
  return value === 'https://' ? '' : value;
};
